export const globalScripts = () => {};
